import { render, staticRenderFns } from "./WorkflowPrepProcessEdit.vue?vue&type=template&id=1b4a73fe"
import script from "./WorkflowPrepProcessEdit.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepProcessEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports